import { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { toast } from "react-toastify";

const ResetPassword = () => {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const backend_url = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch(
      `${backend_url}/api/users/reset-password/${token}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({password}),
      }
    );
    const json = await response.json();
    if (response.ok) {
      toast.success(json.message);
    } else {
      toast.error(json.error);
    }
  };

  return (
    <div className="reset-password-form card">
        <h2 className="title">Reset Password</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter new password"
          required
        />
        <button type="submit">Reset Password</button>
      </form>
      <p className="form-foot-signup">
         <Link to="/login">Go to Login Page</Link>
        </p>
    </div>
  );
};

export default ResetPassword;
